<div id="update-vcc-dialog-confirmpopup" class="confirmpopup">
    <div id="update-vcc-dialog-dialog-title" mat-dialog-title>
      <label id="update-vcc-dialog-title-label" class="title">Update VCC: Confirmation</label>
    </div>
    <hr id="update-vcc-dialog-first-hr">
    <div id="update-vcc-dialog-dialog-content" mat-dialog-content>
      <p id="update-vcc-dialog-content-p">Are you sure you want to update virtual credit card with the booking total amount plus 10% for '{{data.adxBookingId}}' service?</p>
    </div>
    <hr id="update-vcc-dialog-second-hr">
    <div id="update-vcc-dialog-dialog-actions" mat-dialog-actions style="float: right;">
      <button
        id="update-vcc-dialog-ok-button"
        type="submit" mat-raised-button
        (click)="okClick()"
        color="primary"
        cdkFocusInitial matTooltip="Update Virtual Credit Card"
        aria-label="Update Virtual Credit Card">
      <mat-spinner
        id="update-vcc-dialog-spinner"
        color="accent"
        *ngIf="isLoadingSpinner"
        diameter="30">
      </mat-spinner>
        <span id="update-vcc-dialog-ok-span" *ngIf="!isLoadingSpinner">Ok</span>
      </button>
      <button
        id="update-vcc-dialog-no-button"
        mat-raised-button
        (click)="onNoClick()"
        color="warn">
        No Thanks
      </button>
    </div>
  </div>
